export interface MortgageFormData {
  // Step 1: Property and Mortgage Details
  propertyRegion: 'england-wales' | 'scotland';
  mortgageTermYears: number;
  mortgageTermMonths: number;
  interestRate: number;
  revertRate: number;
  productType: '2-year-fixed' | '2-year-tracker' | '5-year-fixed';
  
  // Step 2: Personal Details
  currentAge: number;
  retirementAge: number;
  employedIncome: number;
  selfEmployedIncome: number;
  pensionIncome: number;
  
  // Step 3: Monthly Outgoings
  leisureExpenses: number;
  loanRepayments: number;
  householdExpenses: number;
  dependentsCosts: number;
}

export interface MortgageResult {
  approved: boolean;
  maxLoanAmount?: number;
  monthlyPayment?: number;
  rejectionReason?: string;
  contactDetails?: {
    phone: string;
    email: string;
    advisorName: string;
  };
}

export interface FormStep {
  id: number;
  title: string;
  description: string;
  fields: string[];
}

export const FORM_STEPS: FormStep[] = [
  {
    id: 1,
    title: "Property & Mortgage Details",
    description: "Tell us about the property and mortgage you're looking for",
    fields: ['propertyRegion', 'mortgageTermYears', 'mortgageTermMonths', 'interestRate', 'revertRate', 'productType']
  },
  {
    id: 2,
    title: "Personal Information",
    description: "We need some details about you and your income",
    fields: ['currentAge', 'retirementAge', 'employedIncome', 'selfEmployedIncome', 'pensionIncome']
  },
  {
    id: 3,
    title: "Monthly Outgoings",
    description: "Help us understand your monthly expenses",
    fields: ['leisureExpenses', 'loanRepayments', 'householdExpenses', 'dependentsCosts']
  }
];

export const PROPERTY_REGIONS = [
  { value: 'england-wales', label: 'England and Wales' },
  { value: 'scotland', label: 'Scotland' }
];

export const PRODUCT_TYPES = [
  { value: '2-year-fixed', label: '2 Year Fixed' },
  { value: '2-year-tracker', label: '2 Year Tracker' },
  { value: '5-year-fixed', label: '5 Year Fixed' }
]; 